import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "re-user-profile-name-title-warning-modal",
  templateUrl: "./user-profile-name-title-warning-modal.component.html",
  styleUrls: ["./user-profile-name-title-warning-modal.component.scss"],
  standalone: true,
})
export class UserProfileNameTitleWarningModalComponent {
  constructor(private activeModal: NgbActiveModal) {}

  close(): void {
    this.activeModal.close(false);
  }

  acknowledge(): void {
    this.activeModal.close(true);
  }
}
